import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { APP_BASE_URL } from '../../../config.js'
import { API_BASE_URL } from '../../../config.js'
// import DataTable,{defaultThemes} from 'react-data-table-component';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../../Pagination/Paginations.js';
import EntriesSelector from '../../Pagination/EntriesSelector';
import useSortData from '../../Pagination/SortData';

import '../../../Makepayment.css';






import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const MysalaryControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	function getDate() {
		const today = new Date();
		const month = today.getMonth() + 1;
		const year = today.getFullYear();
		const date = today.getDate();
		return `${year}-${month}-${date}`;
	  }


	const [user, setUser] = useState({
        start_date: getDate(),
        end_date: getDate(),
        shift_id:"ALL",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	// const [dataval, setdataval]= useState([]);
    // const [isVisible, setIsVisible] = useState(false);
	// const [urlres, setUrlRes] = useState(false);
	// const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [dialogmakepayment, setdialogmakepayment]= useState([]);

    // const handelInput = (event) => {
    //     event.preventDefault();
    //     const { name, value } = event.target;
    //     console.log(name, value)
    //     setUser({ ...user, [name]: value });

    //     if (event.target.value === '1') {
    //         setIsVisible(true);
    //       } else {
    //         setIsVisible(false);
    //       }
    // }

	const { sortConfig, sortData, handleSort } = useSortData();

	

	const clearInput = () => {
		setSearchTerm("");
	  };



	  const handleUpdateMakepayment = async (id) => {
	  
			// console.log(user_id);
			// console.log(attn_date);
			try{
	  
			const res =await axios.get(API_BASE_URL + '/make_payment_view/' + id , {
				headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			})
			   
				// console.log(res.data.dialog_make_payment);
				setdialogmakepayment(res.data.dialog_make_payment);
	  
		  // Use jQuery to show modal
		  setTimeout(() => {
			window.$('#payslipDetailsModal').modal('show');
		  }, 100);
		} catch (err) {
		  console.error(err);
		  toast.error("Error fetching payslip data.");
		}
	  };



	  const imagepath=APP_BASE_URL+'/aah-api/uploads/profile/'+dialogmakepayment.profile_picture;
	  const default_user=APP_BASE_URL+'/aah-api/uploads/profile/user.png';
	  


	const handleUpdate = async (id) => {
		window.open(API_BASE_URL +'/payslip/'+id, '_blank')

		// axios.get(API_BASE_URL +'/payslip/'+id, {
		// 	headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		// })
		// .then(res1 => setUser(res1.data))
		// .catch(err => console.log(err))
	   };


	//    const handleUpdate1 = async (id) => {

	// 	axios.get(API_BASE_URL + '/showurl/' + id, {
	// 		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	// 	})
	// 		.then(res1 => setUser(res1.data))
	// 		.catch(err => console.log(err))
	// };


  useEffect(()=> {
	axios.get(API_BASE_URL +'/paysliplist', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])

		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = data.filter((item) =>
		`${item.amount.toLowerCase()}${item.month_payment.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		 );
		 	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
			const indexOfLast = currentPage * entriesPerPage;
			const indexOfFirst = indexOfLast - entriesPerPage;
	// 		const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

	// const startIndex = (currentPage - 1) * entriesPerPage;

		 	const sortedItems = sortData(filteredItems);
			const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		// const paginate = (pageNumber) => setCurrentPage(pageNumber);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	//   const handleRowsPerPageChange = (e) => {
	// 	setItemsPerPage(Number(e.target.value));
	// 	setCurrentPage(1); // Reset to first page
	//   };


	const columns = [
  { label: "Payment Id", key: "emp_name", sortable: true },
  { label: "Paid Amount", key: "shift_date", sortable: true },
  { label: "Payment Month", key: "shift_name", sortable: true },
  { label: "Payment Status", key: "punch_in", sortable: false }
];


	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										 <div className="card-header">
											<h3 className="card-title" style={{color:'#e96827'}}>My Salary</h3>
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>

										</div> 

									
										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>

															<th>Action</th>
															 {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	 {col.sortable && (
																			sortConfig.key === col.key
																				? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																				: " ⇅"   // <-- DEFAULT SORT ICON
																			)}
																	</th>
																))}
															
															
															
														</tr>
													</thead>
													<tbody>
													{data.length > 0 ? (
															filteredData.map((record) => { 
    														let action;
															let requestbtn;
                                                           
                                                              if ((record.payment_method === "VERD")&& (record.is_paid === "PAID")) {

																
																	action = (
        <Link to={`/payslipdisplay-request?id=${record.payment_id}`}>
            <button className='btn' style={{ backgroundColor:'#4ded4d'}}>PAID</button>
        </Link>
    );
																


                                                                    // action = <button className='btn' style={{ backgroundColor:'#4ded4d'}} onClick={() => handleUpdate(record.payment_id)}>PAID</button>;
                                                                  } else if ((record.payment_method === "VERD")&& (record.is_paid === "INPR")) {
                                                                    action = <button className='btn' style={{backgroundColor:'#ff9e9ee6' }}>Activate</button>;
                                                                  } else if (record.payment_method === "INPR") {
                                                                    action = <button className='btn' style={{ backgroundColor:'#ff9e9ee6' }}>WAITING</button>;
                                                                  }
                                                                  else if (record.payment_method === "REGT") {
                                                                    action = <button className='btn' style={{ backgroundColor:'#ff9e9ee6' }}>HOLD</button>;
                                                                  } else {
                                                                    action = <button className='btn'>IN PROGRESS</button>;
                                                                  }

																
																  if(record.payslip_request_check==0)
																  {

																	requestbtn=<Link to={`/employee-payslip?id=${record.payment_id}`}>
																	<i className="fe fe-edit" />
																	</Link>;

																  }
																  else
																  {
																	requestbtn='';
																  }



    														return(
															<tr key={record.payment_id}>
                                                                <td><button
																		type="button" onClick={() =>{ handleUpdateMakepayment(record.payment_id)}}
																		className="btn btn-primary"
																		data-toggle="modal"
																		data-target="#payslipDetailsModal"
																		>
																	Show
																	</button> {requestbtn}</td>
																<td>{record.payment_id}</td>
																<td>{record.amount}</td>
																<td>{record.month_payment}</td>
                                                                <td>{record.paid_on}</td>
																<td>{action}</td>
															</tr>
														
    )
                                                        
})
														) : (
															<tr>
															<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>

			 								<Pagination
											currentPage={currentPage}
											totalPages={totalPages}
											onPageChange={setCurrentPage}
											/>


										</div> 
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 



   <div className="modal fade" id="payslipDetailsModal" tabIndex="-1">
  <div className="modal-dialog modal-md modal-dialog-centered">
    <div className="modal-content">

      {/* HEADER */}
      <div className="modal-header border-0 pb-1">
        <h5 className="modal-title fw-bold">
          Salary Details of {dialogmakepayment?.month_year}
        </h5>
        <button
  type="button"
  className="close"
  data-dismiss="modal"
  aria-label="Close"
>
  <span aria-hidden="true">&times;</span>
</button>

      </div>

      {/* BODY */}
      <div className="modal-body p-0">
  <div className="row g-0" style={{ minHeight: "300px" }}>

    {/* LEFT : IMAGE (col-4 FULL) */}
    <div className="col-4">
      <img
        src={imagepath ? imagepath : default_user}
        alt="Profile"
        style={{
          width: "90%",
          height: "50%",
           objectFit: "cover"
        }}
      />
    </div>

    {/* RIGHT : CONTENT (col-8 FULL) */}
    <div className="col-8 p-3">

      {/* EMPLOYEE NAME */}
      <h6 className="fw-bold mb-2">
        {dialogmakepayment?.first_name} {dialogmakepayment?.last_name}
      </h6>

      {/* EMP INFO */}
      <table className="table table-borderless table-sm mb-2">
        <tbody>
          <tr>
            <td className="fw-bold">EMP ID:</td>
            <td>{dialogmakepayment?.employee_id}</td>
          </tr>
          <tr>
            <td className="fw-bold">Department:</td>
            <td>{dialogmakepayment?.department_name}</td>
          </tr>
          <tr>
            <td className="fw-bold">Designation:</td>
            <td>{dialogmakepayment?.designation_name}</td>
          </tr>
          <tr>
            <td className="fw-bold">Joining Date:</td>
            <td>{dialogmakepayment?.date_of_joining}</td>
          </tr>
        </tbody>
      </table>

      {/* SALARY DETAILS */}
      <div className="border-top pt-2">
        <h6 className="fw-bold mb-2">SALARY DETAILS</h6>
        <table className="table table-borderless table-sm">
          <tbody>
            <tr>
              <td className="fw-bold">Salary Month:</td>
              <td>{dialogmakepayment?.month_year}</td>
            </tr>
            <tr>
              <td className="fw-bold">Gross Salary:</td>
              <td>₹{dialogmakepayment?.gross_salary}</td>
            </tr>
            <tr>
              <td className="fw-bold">CTC:</td>
              <td>₹{dialogmakepayment?.ctc}</td>
            </tr>
            <tr>
              <td className="fw-bold">Net Take:</td>
              <td>₹{dialogmakepayment?.net_take}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

    </div>
  </div>
</div>




										
	



			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(MysalaryControl);